import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import * as revealActions from '../../../actions/revealActions';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import * as bookApi from '../../../services/api/bookApi';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

const parseLinkedClassrooms = response => {
  const data = response && response.data;
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.data)) {
    return data.data;
  }
  return [];
};

class LinkedBookModal extends React.Component {
  static propTypes = {
    revealActions: PropTypes.any,
    classroomActions: PropTypes.any,
    customMessage: PropTypes.string,
    book: PropTypes.object,
    classroom: PropTypes.object
  };

  constructor(context, props) {
    super(context, props);
    this.state = { linkedClassrooms: [] };
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.loadLinkedClassrooms();
  }

  componentDidUpdate(prevProps) {
    const wasClosed = !prevProps.linkedBookModalObject?.opened;
    const isOpen = this.props.linkedBookModalObject?.opened;
    if (wasClosed && isOpen) {
      this.loadLinkedClassrooms();
    }
  }

  loadLinkedClassrooms() {
    const { book, classroom } = this.props;
    if (!book?.activityId || !classroom?.sectionId) {
      return;
    }

    bookApi
      .getLinkedClassroomsForActivity(book.activityId, classroom.sectionId)
      .then(res => {
        this.setState({ linkedClassrooms: parseLinkedClassrooms(res) });
      })
      .catch(() => this.setState({ linkedClassrooms: [] }));
  }

  closeModal = () => {
    this.props.revealActions.setLinkedBookModalOpened(false);
  };

  isTeacherInClassroom = linkedClassrooms => {
    const { activeClassrooms } = this.props;
    const classroomIds = activeClassrooms.map(activeClassroom => activeClassroom.id);

    return (
      <ul>
        {linkedClassrooms.map((linkedClassroom, i) => {
          if (classroomIds.includes(linkedClassroom.id)) {
            return (
              <li className="text-grey-700" key={`assigned-classroom-${i}`}>
                {linkedClassroom.name}
              </li>
            );
          }
        })}
      </ul>
    );
  };

  render() {
    const {
      linkedBookModalObject: { customMessage, opened }
    } = this.props;
    const { linkedClassrooms } = this.state;

    return (
      <Modal
        id="LinkedBookModal"
        title={I18n.t('bookContainer.classroomSynchronizedButton')}
        active={opened}
        onClickOutside={this.closeModal}
        children={
          <>
            <Paragraph className="text-grey-700 gutterBottom">{customMessage}</Paragraph>
            <Paragraph className="text-grey-700" type="span">
              {this.isTeacherInClassroom(linkedClassrooms)}
            </Paragraph>
            <Paragraph className="text-grey-700">{I18n.t('bookContainer.desynchronizeInfo6')}</Paragraph>
          </>
        }
        footer={
          <>
            <Button onClick={this.closeModal} label={I18n.t('common.ok')} />
          </>
        }
      />
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    linkedBookModalObject: state.reveal.linkedBookModalObject,
    activeClassrooms: state.classrooms.activeClassrooms,
    book: state.book.book,
    classroom: state.classrooms.selectedClassroom.classroom
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkedBookModal);
